// extracted by mini-css-extract-plugin
export var active = "_cw-c";
export var compactArrow = "_cw-5";
export var container = "_cw-0";
export var dot = "_cw-b";
export var dotContainer = "_cw-a";
export var hoverArrowButton = "_cw-7";
export var hoverArrowContainer = "_cw-6";
export var leftHoverArrowContainer = "_cw-8 _cw-6";
export var rightHoverArrowContainer = "_cw-9 _cw-6";
export var slide = "_cw-4";
export var sliderContainer = "_cw-1";
export var sliderContainerVisibleOverflow = "_cw-2";
export var sliderOverflow = "_cw-3";
export var vignetteBoth = "_cw-f";
export var vignetteLeft = "_cw-e";
export var vignetteRight = "_cw-d";